import Introduction from "../../Pages/Components/Mms";

export const endpoints = {
  pageSetting: {
    navFooter: "/page/site_settings"
  },

  Banner: {
    getBanner: '/home-banners',
    getBannerCarsousel: "home-sec-one"
  },

  Career: {
    getCarrers: "/career-content",
    cmsCareerData: "/page/career",
    careerForm: "/apply-form"
  },

  Csr: {
    getCsrData: "/csr-content",
    cmsCsrData: "/page/csr"
  },

  ModuleMounting: {
    getModuleMountingManufaturing: "/module-mounting-manufacturing-image",
    getHighTensile: "/module-mounting-high-tensile-image",
    getProductData: "module-mounting-product-image",
    Introduction: "/page/module_mounting_introduction",
    CmsModuleMounting: "/page/module_mounting_manufacturing",
    solarPumps: "/page/module_mounting_solar_pump",
    products: "/page/module_mounting_product",
    quality_safety: "/page/module_mounting_quality_safety",
    technical_specification: "/page/module_mounting_technical",
    product_portfolio: "/page/module_mounting_product_profile",
    infrastrutre_machinery: "/page/module_mounting_infrastructure",
    module_mounting_introduction: "/page/module_mounting_introduction",
    profile_Availability: "/page/module_mounting_profile_availability"
  },


  TowerLineTransmission: {
    towerLineTransmissionIntroduction: "/tower-page",
    towerLineTransmissionCapabilities: "/tower-details",


  },

  Media: {
    getMediaDownload: "/media-downloads",
    galleryCategory: "/media-gallery-categories",
    cmsMedia: "/page/media"
  },


  WorldMap: {
    homeWorlMap: "/page/map_settings",
    mapList: "/map-list",
    mapSingle: (slug) => `/map-single/${slug}`,
  },


  HomeCms: {
    getHomeCms: "/page/home",
    client: "/our-client"
  },

  Initiatives: {
    allNotice: "/notice",
    noticeDetails: (id) => `/notice-details/${id}`
  },


  AboutUs: {
    getBlockData: "/blog",
    groupPofile: "/page/about_group_profile",
    companyProfile: "/page/about_company_profile",
    our_vision: "/page/about_vision",
    ManagmentTeamData: "/management",
    clientImage: "about-client-image",
    getAwardRecognition: "/about-award-image",
    getAwardRecognitionCmsData: "/about-award-image-category",
    research: "page/about_rnd",
    qualityPolicy: "page/about_quality_policy",
    clientele: "page/about_clientele",
    anualRetuns: "/roc-complance"
  },
  contactUs: {
    getContactUsData: "/contact-address",
    cmsContact: "/page/contact",
    queryForm: "/query-form"
  },

  enqueryForm: {
    submitenqueryForm: "/service-form"
  },

  homeMedia: {
    getHomeMediaData: "/home-media"
  },
  Blog: {
    getBlogData: "/blog-details"
  },
  Testimonials: {
    getTestimonialsData: "/testimonial"
  },
  facilities: {
    getFacilitiesData: "/page/facilities"
  },
  teaProcessingMachinery: {
    drying: "/page/ctc_drying",
    withering: "/page/ctc_withering",
    rolling: "/page/ctc_rolling",
    quality: "/page/ctc_tea_processing_quality",
    fermenting: "/page/ctc_tea_processing_fermanting",
    sorting: "/page/ctc_sorting",
    packing: "/page/ctc_tea_processing_packing",
    workshop: "/page/ctc_workshop_machinery",
    utilities: "/page/ctc_tea_processing_utilities",
    roller: "/page/ctc_roller",
    oxidation: "/page/ctc_oxidation"
  },
  HotDipGalvanization: {
    SettingPage: "/page/hotdip_settings",
    Intoduction: "/page/hotdip_introduction",
    capabilities: "/page/hotdip_capabilities",
    technical_specification: "/page/hotdip_technical",
    GalvanizationProcess: "/page/hotdip_galvanizing",
    Quality_Assurance: "/page/hotdip_quality",
    WhyChooseUs: "/page/hotdip_whychooseus"
  },

  GardenPlantation: {
    harvesting: "/page/gp_harvesting",
    foreign_object_removal: "/page/gp_foreign_object_removal",
    laboratory_quality: "/page/gp_laboratory_quality"
  },
  Orthodox: {
    orthodoxDrying: "/page/orthodox_drying",
    orthodoxWithering: "/page/orthodox_withering",
    orthodoxRolling: "/page/orthodox_rolling",
    orthodoxSorting: "/page/orthodox_sorting",
    orthodoxOxidation: "/page/orthodox_oxidation",
  },
  GreenTea: {
    GreenTeaBlending: "/page/green_tea_blending",
    GreenTeaDrying: "/page/green_tea_drying",
    GreenTeaSorting: "/page/green_tea_sorting",
    GreenTeaSteaming: "/page/green_tea_steaming",
    GreenTeaRoasting: "/page/green_tea_roasting",
    GreenTeaRolling: "/page/green_tea_rolling",
  },
  TpmCard: {
    InnerCard: "/page/tea_processing_category"
  }

}